(() => {
	document.addEventListener("DOMContentLoaded", () => {
		// Group accordion items by their parent column
		const accordionsByParent = new Map();

		for (const item of document.querySelectorAll("[data-accordion-item]")) {
			const parent = item.closest(".t4s-col-inner");
			if (parent) {
				if (!accordionsByParent.has(parent)) {
					accordionsByParent.set(parent, []);
				}
				accordionsByParent.get(parent).push(item);
			}
		}

		// Setup accordion behavior for each group
		for (const items of accordionsByParent.values()) {
			for (const item of items) {
				const title = item.querySelector("[data-accordion-title]");
				const content = item.querySelector("[data-accordion-content]");

				if (title && content) {
					title.addEventListener("click", (e) => {
						e.preventDefault();

						const isActive = item.classList.contains("t4s-active");

						// Close all other accordions in the same parent
						for (const otherItem of items) {
							if (otherItem !== item) {
								otherItem.classList.remove("t4s-active");
								const otherContent = otherItem.querySelector(
									"[data-accordion-content]",
								);
								if (otherContent) {
									otherContent.style.display = "none";
								}
							}
						}

						// Toggle current accordion
						if (isActive) {
							item.classList.remove("t4s-active");
							content.style.display = "none";
						} else {
							item.classList.add("t4s-active");
							content.style.display = "block";
						}
					});
				}
			}
		}
	});
})();
